import React from "react";
import LegalPage from "../components/LegalPage";
import { BRAND } from "../lib/brand";

export default function Cookies() {
  return (
    <LegalPage
      eyebrow="Zásady používání"
      title="Cookies"
      intro="Tato stránka vysvětluje, jak na webu KAME Autopůjčovna používáme soubory cookies."
      sections={[
        { h: "Co jsou cookies", p: "Cookies jsou malé textové soubory, které se ukládají do vašeho zařízení při návštěvě webových stránek. Pomáhají nám zajistit správné fungování webu a zlepšovat vaši uživatelskou zkušenost." },
        { h: "Jaké cookies používáme", list: [
          "Nezbytné cookies – zajišťují základní funkce webu, například proces rezervace a přihlášení do administrace.",
          "Analytické cookies – anonymně nám pomáhají pochopit, jak návštěvníci web používají.",
          "Preferenční cookies – uchovávají vaše nastavení (např. zvolenou kategorii vozů).",
        ]},
        { h: "Správa cookies", p: "Používání cookies můžete kdykoliv omezit či zakázat v nastavení svého prohlížeče. Upozorňujeme, že vypnutí některých cookies může omezit funkčnost webu, zejména proces rezervace." },
        { h: "Kontakt", p: `V případě dotazů ohledně cookies nás kontaktujte na e-mailu ${BRAND.email} nebo telefonicky na ${BRAND.phones[0]}.` },
      ]}
    />
  );
}
